import { Fragment, useEffect, useRef, useState } from "react";
import { Col, Form, Table } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import Loading from "../../../../components/Loading";
import PaginateCard from "../../../../components/PaginateCard";
import {
  getByAuthService,
  getRequestByAuth,
} from "../../../../function/helper";
import setLoadingState from "../../../../function/setLoadingState";
import NewAddress from "../../../../modules/components/addresses/NewAddress";
import MyAddressSearch from "./components/MyAddressSearch";
import LoadingButton from "../../../../components/Loading/LoadingButton";

function MyAddresses() {
  const senderRef = useRef(null);
  const getterRef = useRef(null);

  const [allMyAdds, setAllMyAdds] = useState([]);
  const [allRAdds, setAllRAdds] = useState([]);
  const [loading, setLoading] = useState([true, true]);
  const [senderOrgetter, setSenderOrgetter] = useState(-1);

  const [key, setKey] = useState({
    getter: "",
    sender: "",
  });

  const [pageNumber, setPageNumber] = useState({
    sender: 1,
    getter: 1,
  });
  const [count, setCount] = useState({
    sender: 0,
    getter: 0,
  });

  const [senderNationalCode, setSenderNationalCode] = useState("");
  const [senderPhone, setSenderPhone] = useState("");

  const [fetch, refetch] = useState(0);

  const getAddressSender = async () => {
    setLoading(cur => setLoadingState({ array: cur, index: 0, value: true }));
    const response = await getByAuthService(
      `/address/v1/search/0${key.sender ? "/" + key.sender : ""}?numberpage=${
        pageNumber.sender
      }&numberitems=10${
        senderNationalCode ? "&nationalCode=" + senderNationalCode : ""
      }${senderPhone ? "&phone=" + senderPhone : ""}`
    );

    if (response && response.status === 200) {
      setAllMyAdds(response.data.data);
      setCount(cur => ({ ...cur, sender: response.data.count }));
    }

    setLoading(cur => setLoadingState({ array: cur, index: 0, value: false }));
  };

  const getAddressGetter = async () => {
    setLoading(cur => setLoadingState({ array: cur, index: 1, value: true }));
    const response = await getByAuthService(
      "/address/v1/search/1" +
        (key.getter ? "/" + key.getter : "") +
        `?numberpage=${pageNumber.getter}&numberitems=10`
    );

    if (response && response.status === 200) {
      setAllRAdds(response.data.data);
      setCount(cur => ({ ...cur, getter: response.data.count }));
    }
    setLoading(cur => setLoadingState({ array: cur, index: 1, value: false }));
  };

  useEffect(() => {
    getAddressGetter();
  }, [pageNumber.getter, key.getter]);

  useEffect(() => {
    getAddressSender();
  }, [pageNumber.sender, fetch]);

  const deleteAddress = async id => {
    Swal.fire({
      icon: "info",
      text: "آدرس حذف شود؟",
      showConfirmButton: true,
      confirmButtonText: "مطمئنم",
      showCancelButton: true,
      cancelButtonText: "انصراف",
    }).then(async result => {
      if (result.isConfirmed) {
        setLoading(() => [true, true]);
        const response = await getRequestByAuth(
          "/address/v1/deleteAddress/" + id
        );
        setLoading(() => [false, false]);
        if (response.data) {
          getAddressGetter();
          getAddressSender();
          Swal.fire({
            icon: "success",
            text: response.data,
            showConfirmButton: false,
            confirmButtonText: "متوجه شدم",
          });
        }
      }
    });
  };

  return (
    <Fragment>
      <div>
        <button
          ref={senderRef}
          className="btn btn-primary"
          onClick={() => setSenderOrgetter(() => 0)}
        >
          ثبت آدرس فرستنده جدید
        </button>
        <h4 className="text-secondary mt-5">لیست آدرسهای شما</h4>

        <hr />

        <form
          onSubmit={e => {
            e.preventDefault();
            setPageNumber(cur => ({ ...cur, sender: 1 }));
            refetch(cur => cur + 1);
          }}
        >
          <div className="d-flex flex-wrap mb-3">
            <Col xs="12" sm="6" md="4" xxl="3" className="px-2">
              <Form.Label>کد ملی</Form.Label>
              <Form.Control
                onChange={e => setSenderNationalCode(e.target.value)}
              />
            </Col>
            <Col xs="12" sm="6" md="4" xxl="3" className="px-2">
              <Form.Label>شماره موبایل</Form.Label>
              <Form.Control onChange={e => setSenderPhone(e.target.value)} />
            </Col>

            <Col xs="12" sm="8" className="px-2">
              <Form.Label>جستجو</Form.Label>
              <Form.Control
                placeholder="جستجو با استان، شهر، آدرس، نام"
                onChange={e =>
                  setKey(cur => ({ ...cur, sender: e.target.value }))
                }
              />
            </Col>

            <div className="d-flex align-items-end me-auto">
              {loading[0] && (
                <LoadingButton
                  center
                  className="btn-success"
                  title="در حال جستجو"
                />
              )}
              {!loading[0] && (
                <button className="btn btn-success" type="submit">
                  جستجو
                </button>
              )}
            </div>
          </div>
        </form>

        <Table striped bordered hover className="mb-5">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>کد ملی</th>
              <th>موبایل</th>
              <th>آدرس</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {loading[0] === true && (
              <tr>
                <td colSpan={5}>
                  <Loading />
                </td>
              </tr>
            )}
            {loading[0] === false &&
              allMyAdds.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + (pageNumber.sender - 1) * 10 + 1}</td>
                    <td>{data.address.nationalCode}</td>
                    <td>{data.address.phone}</td>

                    <td>{data.address.totalAddress}</td>

                    {data.address.Default === 1 ? (
                      <td>آدرس پیش فرض</td>
                    ) : (
                      <td>
                        <Trash
                          color="red"
                          title=" حذف آدرس"
                          onClick={() => {
                            deleteAddress(data.address.id);
                          }}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </Table>

        <PaginateCard
          count={count.sender}
          numberItems={10}
          numberPage={pageNumber.sender}
          onIndexChoose={number => {
            setPageNumber(cur => ({ ...cur, sender: number }));
            senderRef.current?.scrollIntoView({ behavior: "instant" });
          }}
        />

        <button
          className="btn btn-primary mt-5"
          onClick={() => setSenderOrgetter(() => 1)}
          ref={getterRef}
        >
          ثبت آدرس گیرنده جدید
        </button>
        <h4 className="text-secondary mt-5">لیست آدرسهای گیرنده ثبت شده</h4>
        <hr />

        <MyAddressSearch
          search={value => {
            setKey(cur => ({ ...cur, getter: value }));
            setPageNumber(cur => ({ ...cur, getter: 1 }));
          }}
        />

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>آدرس</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {loading[1] === true && (
              <tr>
                <td colSpan={3}>
                  <Loading />
                </td>
              </tr>
            )}
            {loading[1] === false &&
              allRAdds.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + (pageNumber.getter - 1) * 10 + 1}</td>
                    <td>{data.address.totalAddress}</td>

                    <td>
                      <Trash
                        color="red"
                        title=" حذف آدرس"
                        onClick={() => {
                          deleteAddress(data.address.id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>

        <PaginateCard
          count={count.getter}
          numberItems={10}
          numberPage={pageNumber.getter}
          onIndexChoose={number => {
            setPageNumber(cur => ({ ...cur, getter: number }));
            getterRef.current?.scrollIntoView({ behavior: "instant" });
          }}
        />
      </div>

      {senderOrgetter !== -1 && (
        <NewAddress
          senderOrgetter={senderOrgetter}
          onClose={number => setSenderOrgetter(number)}
          setResult={() => setSenderOrgetter(-1)}
        />
      )}
    </Fragment>
  );
}

export default MyAddresses;
